import { toast } from 'react-toastify';
import QueryParams from '../../services/QueryParams';
import FormData from '../../services/FormData';
import Http from '../../services/Http';
import Logo from '../../logos/logo-white.png';
import { Link, useHistory } from 'react-router-dom';
import { useCallback, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import IEVersion from '../../services/IEVersion';
import Copyright from '../../common/Copyright';
import PrivacyPolicy from '../../common/PrivacyPolicy';
import OtpInput from 'react-otp-input';
import ReCaptcha from '../../common/ReCaptcha';

const ForgotPassword = (props: any) => {
    const [http] = useState(new Http());
    const [queryParams] = useState(new QueryParams());
    const [processing, setProcessing] = useState(false);
    const [token, setToken] = useState("");
    const [otpSent, setOtpSent] = useState(false);
    const [otp, setOtp] = useState("");
    const history = useHistory();
    const [reCaptchaToken, setReCaptchaToken] = useState("");
    const [reCaptchaTimestamp, setReCaptchaTimestamp] = useState(0);
    const [otpMessage, setOtpMessage] = useState("");

    const resetPassword = useCallback(async (e) => {
        e.preventDefault();
        setProcessing(true);
        const url = token ? "set-password" : (otpSent ? "otp/verify" : "otp");
        try {
            const resp = await http.post(url, new FormData('reset_password_form').toJson())
            if (resp.status < 400) {
                toast.success(resp.data.message);
                if (token) {
                    history.push({
                        pathname: "/login",
                        search: queryParams.search()
                    });
                } else if (otpSent) {
                    setToken(resp.data.token);
                } else {
                    setOtpMessage(resp.data.message);
                    setOtpSent(true);
                }
            } else {
                // eslint-disable-next-line no-mixed-operators
                toast.error(resp && resp.data && resp.data.message || "Something went wrong.");
            }
        } catch (e: any) {
            toast.error(e && e.response && e.response.data && e.response.data.message ? e.response.data.message : ((e && e.message) || "Something went wrong."));
        }
        reCaptchaReload();
        setProcessing(false);
    }, [history, http, otpSent, queryParams, token]);

    const reCaptchaReload = () => {
        setReCaptchaTimestamp(new Date().getTime());
    };

    return (
        <div className="global-container bg-gradient">
            <ReCaptcha action="FORGOT_PASSWORD" reCaptchaTimestamp={reCaptchaTimestamp} onToken={setReCaptchaToken} />
            <div id="tweak">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6 d-flex">
                            <div className="mt-auto mb-auto text-center text-md-left">
                                <img src={Logo} style={{ pointerEvents: 'none' }} width="240" alt="" />
                                <h4 className="text-white mt-4 d-inline-block" style={{ lineHeight: 1.5 }}>
                                    {otpSent ?
                                        (
                                            !token ?
                                                <span>Please enter the one time password we have just sent to your email address to continue.</span> : <span>OTP verification was successful. Please enter new password.</span>
                                        )
                                        : <span>Please enter your email address to continue resetting password.</span>
                                    }
                                </h4>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="card login-form mt-4 ml-auto mr-auto">
                                <div className="card-body">
                                    <div className="card-text">
                                        <form name="reset_password_form" onSubmit={resetPassword} id="reset_password_form">
                                            <input type="hidden" name="reCaptcha" value={reCaptchaToken} />
                                            <div className="form-group" style={{ display: otpSent ? "none" : "block" }}>
                                                {IEVersion() < 10 ? <label>Email address</label> : <span></span>}
                                                {
                                                    <input type="email" placeholder="Email address" className="form-control form-control-lg" id="email" name="email" />
                                                }
                                            </div>
                                            <div className="form-group slideInRight" style={{ display: otpSent && !token ? "block" : "none" }}>
                                                <label>One Time Password</label>
                                                <OtpInput
                                                    value={otp}
                                                    numInputs={6}
                                                    onChange={setOtp}
                                                    separator={<span className='text-muted'>&nbsp;&nbsp;</span>}
                                                    inputStyle={"form-control form-control-lg otp"}
                                                />
                                                <div className="my-4">
                                                    <span className="text-success">{otpMessage}</span>
                                                </div>
                                                <input autoComplete='new-password' value={otp} type="hidden" id="otp" name="otp" />
                                            </div>

                                            <div className="form-group slideInRight" style={{ display: token ? "block" : "none" }}>
                                                {IEVersion() < 10 ? <label>New Password</label> : <span></span>}
                                                {
                                                    <input autoComplete='new-password' type="password" placeholder="New Password" className="form-control form-control-lg" id="password" name="password" />
                                                }
                                            </div>
                                            <div className="form-group slideInRight" style={{ display: token ? "block" : "none" }}>
                                                {IEVersion() < 10 ? <label>Confirm Password</label> : <span></span>}
                                                {
                                                    <input type="password" autoComplete='new-password' placeholder="Confirm Password" className="form-control form-control-lg" id="confirm" name="confirm" />
                                                }
                                            </div>

                                            <input type="hidden" name="reason" value="Reset Password" />
                                            <input type="hidden" name="token" value={token} />
                                            <button type="submit" disabled={processing} className="btn btn-secondary btn-lg btn-block">
                                                {processing ? <span> Please Wait&hellip;</span> : (otpSent ? "Submit" : "Request OTP")}
                                                {processing ? <span>
                                                    &nbsp;&nbsp;
                                                    <FontAwesomeIcon icon={faSpinner} className="fa-spin" />
                                                </span> : <span></span>}
                                            </button>
                                            <div className="sign-up text-center">
                                                <Link to={{
                                                    pathname: "login",
                                                    search: queryParams.search()
                                                }} className="btn btn-success btn-lg">Back to Login</Link>
                                            </div>
                                            <PrivacyPolicy />
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Copyright />
        </div>
    );
}

export default ForgotPassword;